
import Vue from "vue";
export default Vue.extend({
  props: {
    active: {
      type: Boolean,
      default: false
    },
    label: {
      type: String,
      default: ""
    },
    hasSuboption: {
      type: Boolean,
      default: false
    },
    value: {
      default: undefined
    }
  },
  methods: {
    onClick() {
      this.$emit("click", this.value);
    }
  }
});
